// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".geekqoo-loading[data-v-115c0cb5]{position:fixed;z-index:999;top:0;left:0;width:100%;height:100%;background:#fff}.geekqoo-loading .van-loading[data-v-115c0cb5]{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.geekqoo-loading .van-loading .van-loading__text[data-v-115c0cb5]{margin:.15rem 0 0 0;font-size:.18rem}", ""]);
// Exports
module.exports = exports;
